var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "intl-breadcrumb" },
    [
      _c("router-link", { attrs: { to: "/international/home" } }, [
        _vm._v(_vm._s(_vm.$t("nav.home"))),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "intl-breadcrumb__sep" }, [_vm._v("/")]),
      _vm._v(" "),
      !_vm.isDetail
        ? _c("span", [_vm._v(_vm._s(_vm.currentTitle))])
        : [
            _c("router-link", { attrs: { to: _vm.parentPath } }, [
              _vm._v(_vm._s(_vm.parentTitle)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "intl-breadcrumb__sep" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.detailTitle || _vm.$t("common.more"))),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }